function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { AccesoDatos } from '../../../comun/services/acceso-datos';
import './panel-menu.scss';
var PanelMenuComponentCtrl = /*#__PURE__*/function () {
  PanelMenuComponentCtrl.$inject = ["$log", "NotifService", "AccesoDatos"];
  function PanelMenuComponentCtrl($log, NotifService, AccesoDatos) {
    _classCallCheck(this, PanelMenuComponentCtrl);
    this.$log = $log;
    this.NotifService = NotifService;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(PanelMenuComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var $menuResource = this.AccesoDatos.menuResource;

      // $menuResource.findAll().then(listResponse => this.list = listResponse)

      this.AccesoDatos.GestionMenu_CLIENT.menusNavegacion().then(function (response) {
        _this.list = response.root;

        // gestionarn los formularios
        _this.formulars = response.formularios;
      });
    }
  }, {
    key: "nuevoPrincipal",
    value: function nuevoPrincipal() {
      var _nuevo = {};
      _nuevo.m = {};
      _nuevo.m.idmensuper = null;
      this.list.push(_nuevo);
      _scrollBottom();
    }
  }]);
}();
angular.module('candidato').component('panelMenu', {
  bindings: {
    // empresa: "<",
  },
  controller: PanelMenuComponentCtrl,
  template: require('./panel-menu.component.html')
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/panel-menu/panel-menu.component.html"
});
function _scrollBottom() {
  // scroll bottom
  var a = $('.container-fluid');
  if (a && a.length) {
    var _el = a[0];
    setTimeout(function () {
      return _el.scroll({
        behavior: 'smooth',
        top: _el.scrollHeight + 10000
      });
    }, 30);
  }
}